<template>
  <generic-container
    v-bind:searchable="false"
    v-bind:show_plus="true"
    icon="edit"
    :title="$t('receipt templates')"
    v-on:add="add_layout"
    data-tab="receipt"
  >
    <div class="ui grid">
      <div class="four wide column">
        <div
          class="ui vertical fluid pointing menu"
          ref="tabs_layouts"
          v-if="receipt_layouts.length"
        >
          <a
            class="item"
            :data-tab="'t' + idx"
            v-for="(lyt, idx) in receipt_layouts"
            :key="idx"
          >
            <i class="settings icon" :class="{ blue: lyt.set_as_default }"></i>
            {{ lyt.name || $t("unnamed") }}
          </a>
        </div>
      </div>
      <div class="twelve wide stretched column">
        <div
          class="ui tab segment"
          :data-tab="'t' + idx"
          v-for="(lyt, idx) in receipt_layouts"
          :key="idx"
        >
          <div class="ui form">
            <div class="fields">
              <div class="five column wide field">
                <label for>{{ $t("name") }}</label>
                <input
                  type="text"
                  name="name"
                  v-model="receipt_layouts[idx].name"
                />
              </div>
              <div class="eight column wide field">
                <label for>
                  <i class="settings icon"></i>
                </label>
                <div class="ui toggle checkbox">
                  <input
                    type="checkbox"
                    name="set_as_default"
                    v-model="receipt_layouts[idx].set_as_default"
                  />
                  <label>{{ $t("set as default template") }}</label>
                </div>
              </div>
              <div class="one column wide field">
                <label for>{{ $t("options") }}</label>
                <div
                  class="ui red icon button"
                  :data-tooltip="$t('delete')"
                  @click="remove(idx)"
                >
                  <i class="trash icon"></i>
                </div>
              </div>
            </div>
            <div class="field">
              <label for>{{ $t("template") }}</label>
              <!-- <editor
                @init="init_code('html')"
                v-model="receipt_layouts[idx].template"
                lang="html"
                theme="monokai"
              ></editor> -->
              <wysywyg v-model="receipt_layouts[idx].template" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </generic-container>
</template>

<script>
// import { local_api, stringify } from "@/utils";
import GenericContainer from "@/components/GenericContainer";
// import Editor from "vue2-ace-editor";
import { v4 } from "uuid";
import Wysywyg from "@/components/Wysywyg/Wysywyg";

export default {
  name: "Templates",
  components: { GenericContainer, /*editor: Editor*/ Wysywyg },
  props: {
    configuration: Object,
  },
  computed: {},
  data() {
    return {
      receipt_layouts: [],
    };
  },
  methods: {
    init_code(type) {
      require(`brace/mode/${type}`);
      require("brace/theme/monokai");
    },
    add_layout() {
      let layout = {
        id: v4(),
        name: "",
        template: { html: "", js: "", css: "" },
      };
      this.receipt_layouts.push(layout);
    },
    remove_layout(layoout, index) {
      this.receipt_layouts.splice(index, 1);
    },
    get_data() {
      return this.receipt_layouts;
    },
    set_data(layouts) {
      this.receipt_layouts = layouts;
    },
    remove(index) {
      let vm = this;
      vm.$alertify.confirm(
        vm.$t("are you sure to remove template?"),
        function() {
          vm.receipt_layouts.splice(index, 1);
        },
      );
    },
  },
  created() {},
  mounted() {},
  updated: function() {},
  watch: {
    receipt_layouts() {
      setTimeout(() => {
        window
          .jQuery(this.$refs.tabs_layouts)
          .find(".item")
          .tab({
            onLoad() {},
          });
      }, 500);
    },
  },
};
</script>
